/* Action types */
export const TOGGLE_LOADER = 'TOGGLE_LOADER';

/* Action creators */

export function toggleLoader(loading) {
  return {
    type: TOGGLE_LOADER,
    loading,
  }
}



// WEBPACK FOOTER //
// ./src/actions/loader.jsx